import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const CloudBridgeIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="85"
			height="70"
			viewBox="0 0 85 70"
			fill="none"
			{...props}
		>
			<path
				d="M64.6313 69.0283C65.1609 68.9839 65.5194 69.0718 65.7662 68.4609C65.3803 68.6009 64.8999 68.704 64.6313 69.0283Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M54.2287 62.9759C53.9818 62.7442 53.6064 62.7178 53.283 62.5977C53.6073 63.4279 53.9799 62.9589 54.2287 62.9759Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M54.7961 62.9763C54.8028 62.9763 54.8103 62.9763 54.8179 62.9782C54.9881 63.0065 55.3446 63.3933 55.5527 62.7871C55.3342 62.8344 54.9295 62.6614 54.7961 62.9763Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M61.0376 69.0286L60.281 68.6504C60.4541 68.7279 60.3207 68.9511 61.0376 69.0286Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M77.8711 65.624C77.6129 65.6912 77.3093 65.8113 77.1145 66.0023C77.3897 65.9928 77.5817 66.3257 77.8711 65.624Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M81.843 59.7617L81.6567 60.3225C81.6785 60.2818 81.8251 60.14 81.843 59.7617Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M82.9776 50.1162L82.605 50.6751C82.6419 50.6382 82.8442 50.5531 82.9776 50.1162Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M72.3861 69.0283L72.0078 69.2174C72.3331 69.1891 72.3653 69.033 72.3861 69.0283Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M81.4647 61.6523L81.094 62.023C81.1403 61.9909 81.3872 61.8982 81.4647 61.6523Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M80.3298 63.7325L80.3563 63.7061C80.344 63.7155 80.3355 63.724 80.3298 63.7325Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M80.708 63.3545L80.3562 63.7063C80.4252 63.6495 80.5879 63.571 80.708 63.3545Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M73.4963 68.4854L73.1426 68.839C73.3762 68.7227 73.4377 68.5563 73.4963 68.4854Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M81.3814 58.426C81.231 57.6969 80.2295 56.4062 80.2144 56.0771C80.1945 55.6695 81.5299 53.1419 81.7947 52.4317C93.1118 22.131 67.8968 -6.69916 36.409 1.37553C26.4915 3.91831 18.2621 10.1349 12.2749 18.2833C11.9524 18.723 10.758 20.793 10.5376 20.9027C10.0459 21.1476 8.42118 20.3117 7.6041 20.236C3.23027 19.8332 -0.387006 22.7674 0.134071 27.3263C0.261739 28.4374 1.232 29.3982 1.27361 29.7897C1.32468 30.2757 0.832938 31.0076 0.748771 31.5315C0.321318 34.1802 1.99518 36.8601 4.51924 37.6941C4.95142 37.8379 5.6361 37.7329 5.9113 38.0043C6.11746 38.2095 6.42102 39.6015 6.78606 40.1556C8.1384 42.2066 10.044 42.0431 12.221 41.8152C12.6172 43.9353 13.5383 45.3234 15.2661 46.5225C17.4298 48.0241 21.2958 48.1802 23.6459 46.8639C24.0034 46.6643 24.9207 45.8246 25.0313 45.8029C25.3254 45.7443 26.6485 46.375 27.1355 46.4743C29.8004 47.0171 31.1925 46.0989 32.4777 43.8747C33.274 42.496 33.6948 41.8 33.3402 40.0809C33.2068 39.435 32.5004 38.5859 32.4749 38.0894C32.4484 37.5722 33.3241 36.687 33.4281 35.8417C33.4877 35.3584 33.4877 34.2417 33.4121 33.7679C33.3449 33.3509 32.909 32.8336 32.9213 32.6227C32.9543 32.0686 35.8671 29.5003 36.4648 29.0436C47.0821 20.9377 59.6002 26.6436 58.576 40.3731C58.5335 40.9471 57.8932 44.6104 57.6067 44.7939C57.3826 44.9367 55.8004 44.7419 55.1677 44.9083C54.0121 45.2128 53.2338 46.6331 52.4782 46.9471C52.0403 47.1296 51.5845 47.0388 51.193 47.175C45.9869 48.9839 46.6773 55.8634 51.5505 57.522C51.0956 61.2941 52.8839 63.8236 56.7839 62.0383C57.236 62.0752 57.0222 64.1981 57.1111 64.7277C57.7589 68.6217 62.6434 69.4577 65.8153 68.2265C66.325 68.0279 67.6698 67.1324 67.9459 67.1399C68.3289 67.1485 68.7271 67.8179 69.1072 68.0515C71.1916 69.3328 73.0385 69.1031 74.5497 67.1258C74.8249 66.7655 75.0358 65.8955 75.4103 65.7168C75.8501 65.5087 77.2998 65.5721 78.063 65.3433C80.326 64.6643 81.8297 60.601 81.3814 58.426ZM11.8588 21.8398C11.9874 20.9575 15.1526 16.9793 15.9253 16.0705C29.651 -0.0580482 54.9218 -3.92849 71.254 10.6805C83.7362 21.8455 86.2479 40.1102 79.1921 55.0331C77.6715 54.462 76.808 54.5489 76.7503 52.6407C76.7031 51.0672 78.15 46.9149 78.4129 44.8894C79.491 36.5953 78.3334 27.836 73.9776 20.6284C62.2254 1.17977 36.6898 2.96039 21.1266 16.7325C20.2017 17.5514 17.2738 20.9556 16.5853 21.2743C16.174 21.4644 14.4944 21.1107 13.3766 21.4653C13.0551 21.5665 11.7566 22.5348 11.8588 21.8398ZM68.6477 22.1755C58.2999 7.27528 38.1462 8.9793 25.2015 19.4833C24.4355 20.1036 22.4326 22.2814 21.8358 22.5481C20.9989 22.9216 19.5321 22.966 18.6053 23.4341C18.332 23.1173 17.6417 22.4648 17.7448 22.0686C17.8223 21.7698 21.52 18.1641 22.0723 17.6781C33.9908 7.18544 52.5075 2.66346 65.9354 13.1618C77.1239 21.9088 79.7132 37.5466 75.7886 50.6832L72.7529 49.4246C74.562 40.2076 74.145 30.0913 68.6477 22.1755ZM59.3184 20.9131C50.3277 14.6559 38.9198 16.3476 30.261 22.2729C28.8879 23.2119 27.6414 24.2918 26.3506 25.332C25.5155 24.3306 24.7675 23.4124 23.592 22.7873C25.0351 21.3074 26.6333 19.9249 28.3167 18.7211C28.5928 18.7183 28.8018 18.6143 28.8841 18.3429C50.409 3.66393 74.2972 16.5774 72.5836 42.8431C72.4484 44.9216 71.7732 47.1126 71.4384 49.1702C70.7982 48.791 70.7509 47.8719 70.4114 47.2686C69.7777 46.1424 68.711 45.3859 67.6443 44.6908C69.5517 36.2114 66.6116 25.9892 59.3184 20.9131ZM13.1061 40.2672C12.0536 39.5107 10.1036 41.3896 8.44765 39.818C7.48966 38.9074 7.67123 37.1305 7.27971 36.7315C6.81916 36.2615 5.98884 36.5263 5.57652 36.4468C3.14703 35.9807 2.03207 33.8833 2.41602 31.4984C2.53517 30.7561 3.1584 30.3977 2.97115 29.4133C2.83781 28.7069 1.76539 28.3041 1.6415 26.7665C1.30767 22.6001 5.79214 20.6313 9.22122 22.2124C9.88699 22.5187 11.3159 23.7632 11.7822 23.8284C12.8669 23.9797 14.0027 22.0885 15.8789 22.9329C16.9457 23.4124 17.6965 25.1353 17.845 25.1665C18.5164 25.3083 19.2361 24.5282 19.8054 24.3003C21.7186 23.5372 24.0365 23.9835 24.9491 25.9656C25.334 26.8034 25.4096 28.5357 25.9619 29.1135C26.534 29.7121 27.7691 29.4284 28.2249 29.8767C28.693 30.3372 28.5361 31.8719 28.9796 32.3372C29.5479 32.9329 31.1348 32.5036 31.8668 33.9911C32.786 35.8587 30.244 37.2024 30.8729 38.583C30.9722 38.8015 31.2492 38.8506 31.3429 38.9575C32.1647 40.636 32.1855 41.9476 31.0421 43.4795C30.0274 44.8412 29.2151 45.2364 27.4816 44.9925C27.2499 44.9603 27.0267 44.896 26.8111 44.8175C26.4555 44.6114 26.1208 44.4639 25.8078 44.375C25.8068 44.375 25.8059 44.374 25.8049 44.374C24.9056 43.9684 24.1357 43.784 23.399 45.3877C21.2599 46.5613 17.1547 46.6331 15.3522 44.8289C14.1606 43.6365 13.5743 40.6038 13.1061 40.2672ZM54.7961 26.8535C54.6476 26.7277 54.6069 26.4195 54.2286 26.4752C46.979 20.7656 37.9079 25.3169 32.3737 31.0133C31.9273 31.4719 32.3075 31.714 31.2994 31.5362C29.4316 31.2072 30.3622 30.0157 29.3664 28.9244C28.4727 27.9447 26.0281 28.3769 26.901 26.479C27.1081 26.0299 29.7551 23.9069 30.3348 23.4814C37.6734 18.0828 47.9436 15.9826 56.313 20.3249C64.9254 24.793 68.5635 34.9982 66.3156 44.2341C64.8072 44.2067 63.2373 44.3182 61.8547 44.9755C61.3469 45.2166 60.4192 46.1026 59.987 46.1452C59.587 46.1849 58.9987 45.9249 58.9496 45.4814C58.9098 45.1201 59.7298 42.775 59.8518 42.027C60.7776 36.3192 59.2522 30.6303 54.7961 26.8535ZM79.9345 60.0289C79.8664 60.5527 78.7136 63.1239 78.3788 63.4851C77.539 64.3901 75.0784 63.8047 74.2745 64.2028C73.6882 64.4941 73.6504 66.9867 71.9046 67.3168C70.1466 67.6477 69.2813 66.2567 68.1029 65.2742C65.6318 66.9839 62.0968 68.5858 59.5179 66.1035C57.8554 64.5026 58.716 61.0444 58.2024 60.6104C57.3135 59.8596 55.2718 61.4823 53.8381 61.001C52.533 60.5622 53.3719 57.7215 53.0579 56.6766C52.9141 56.2 51.3831 55.8388 50.7627 55.3783C48.946 54.0288 48.4902 51.0511 50.2681 49.4653C51.1514 48.6776 52.0772 48.7655 52.8905 48.305C53.7322 47.8294 54.5615 46.2435 55.6879 45.9939C57.6615 45.5561 58.7217 47.6033 59.8064 47.6761C60.7473 47.7395 61.3195 46.8866 62.042 46.4866C64.462 45.1457 67.4041 45.227 69.0637 47.6695C69.6699 48.5613 69.896 50.6672 70.5759 51.0728C71.4422 51.5892 72.6574 50.6672 74.0807 51.5419C75.7517 52.5679 75.2628 54.7381 75.9673 55.5182C76.2624 55.8445 77.522 56.0033 78.1244 56.3873C79.2905 57.1324 80.1132 58.6445 79.9345 60.0289Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M19.5321 44.4477C20.0929 43.5569 17.5074 42.9508 16.9049 42.5196C16.3716 42.1385 15.7607 40.8657 15.1781 41.0397C14.7961 41.1532 14.8471 41.8983 14.9332 42.2208C15.2831 43.5352 18.8398 45.5456 19.5321 44.4477Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M29.5423 38.9602C28.4784 38.7663 29.4458 40.301 29.4533 40.9393C29.459 41.4925 28.6684 43.6476 28.885 43.8736C30.888 43.8008 31.2748 39.2741 29.5423 38.9602Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M22.0202 43.3421C21.7715 43.4168 21.502 43.7015 21.5029 43.9691C22.4013 45.9048 23.9977 42.7445 22.0202 43.3421Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M21.7837 12.8572C22.3275 12.8014 25.3792 10.53 26.1783 10.0582C28.0801 8.93477 30.0973 7.98723 31.9764 6.82317L32.0993 6.0506C31.6435 5.57779 27.2772 8.11773 26.5575 8.5461C25.7859 9.00472 21.099 11.9844 21.134 12.5754C21.1463 12.7816 21.5492 12.8808 21.7837 12.8572Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M41.4646 3.972C42.4103 3.91148 47.7081 4.15356 47.9681 3.76207C48.0599 3.62496 48.005 3.17673 47.9 3.01598C47.3459 2.17437 41.5762 2.80037 40.4243 3.12094C39.9969 3.23914 39.1533 3.35356 39.0938 3.87271C39.0938 4.78145 40.9085 4.00793 41.4646 3.972Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M36.0705 4.81787C36.1717 4.33655 35.4199 4.2751 35.0709 4.38384C34.8459 4.45288 34.7097 4.66279 34.5593 4.82355C34.425 5.4732 35.8341 5.44671 36.0705 4.81787Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M77.4341 57.5512C77.1154 57.2542 76.0354 56.8202 75.8132 57.4225C75.5664 58.0892 76.6208 58.3578 76.7315 59.3062C76.8648 60.4448 75.6694 61.3223 76.4581 62.2178C77.5599 62.5507 78.7335 58.7616 77.4341 57.5512Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M66.0516 47.3653C65.4908 47.3605 64.8724 47.8996 65.2176 48.397C65.3027 48.5199 67.5562 49.1648 67.7548 49.926C69.215 49.2783 66.9737 47.3738 66.0516 47.3653Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M68.6041 50.6841C68.4765 51.0727 68.8103 51.9049 69.2624 51.8169C69.9187 51.6893 69.3257 50.4051 68.6041 50.6841Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M61.31 27.9976C61.5786 28.1527 62.0883 28.3115 62.338 28.1536C62.8373 27.8387 62.1706 26.9243 61.9502 26.6019C60.7937 24.9035 58.1892 22.4732 56.3092 21.6524C55.9611 21.5002 54.5407 20.895 54.4187 21.4662C54.3242 21.9068 57.2832 23.817 57.8251 24.2974C58.7992 25.1617 60.4835 27.5201 61.31 27.9976Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M64.0734 41.5982C64.1972 41.706 64.741 41.6048 64.9207 41.4214C65.5307 40.7992 65.9808 35.3987 64.9122 35.1765C64.6181 35.115 64.4895 35.3978 64.445 35.6512C64.3164 36.3765 63.8473 41.4025 64.0734 41.5982Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
			<path
				d="M63.4963 31.4875C64.7144 32.0785 64.2784 30.3811 63.8254 29.9263C62.9374 29.0355 62.4854 30.9967 63.4963 31.4875Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
		</svg>
	);
};

export default memo(CloudBridgeIcon);
